import { type Href } from 'expo-router';

import { APPLE_APP_ID } from '../config/config';

export const APPLE_APP_STORE_URL: Href = `https://apps.apple.com/us/app/fruitful-money/id${APPLE_APP_ID}`;

export const SESSION_DURATION_MINUTES = 15;

export const STYTCH_ERROR_MESSAGE_BY_TYPE: Record<string, string> = {
    invalid_email: 'This email is invalid. Please try again.',
    invalid_code: 'Please enter a valid code with 6 digits.',
    duplicate_email: 'This email is already being used.',
    unauthorized_credentials: 'Incorrect credentials, please try again.',
    unable_to_auth_magic_link:
        'This link is invalid because it was either already used or expired. Please generate a new one.',
    magic_link_not_found:
        'This link is invalid. Please try sending another one.',
    email_not_found: 'Incorrect credentials, please try again.',
    unable_to_auth_otp_code:
        'Your code has expired. Please request a new one and try again.',
    otp_code_not_found:
        'That code is incorrect. Please try again or request a new code.',
    duplicate_phone_number:
        'There was a problem with sending you a text. Try email instead.',
    no_otp_method_id:
        "There's a problem with this code. Try resending or using the other method.",
    breached_password:
        'This password may have been used on a different site that experienced a security issue. Please choose another password.',
    weak_password:
        "Password isn't strong enough. Please choose a stronger password.",
};

export const ROUTE_PATHS_EXCLUDED_FROM_STORED_REDIRECT = [
    /^\/?$/,
    /^\/home\/?$/,
    /^\/sign-in\/?$/,
    /^\/sign-in\/email.*$/,
    /^\/sign-in\/otp.*$/,
    /^\/sign-in\/forgot-password.*$/,
    /^\/sign-in\/forgot-password\/finish.*$/,
    /^\/reset-password.*$/,
    /^\/sign-up\/.*$/,
];
